(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
"use strict";

var animateBars = {
    bars: function bars() {

        // vars
        var pinkBar = ".pinkBar",
            movBar = ".movBar",
            movBar2 = ".movBar2",
            brownBar = ".brownBar",
            pinkBar2 = ".pinkBar2",
            orangeBar = ".orangeBar";

        animate(movBar, 3, -5);
        animate(pinkBar, 2, 10);
        animate(movBar2, 2, -27);
        animate(brownBar, 2, -18);
        changeColor(pinkBar2, 2, "#CD142F");

        function animate(selector, speed, x) {
            TweenMax.to(selector, speed, {
                x: x,
                repeat: -1,
                yoyo: true
            });
        }

        function changeColor(selector, speed, fill) {
            TweenMax.to(selector, speed, {
                fill: fill,
                repeat: -1,
                yoyo: true
            });
        }
    }

};

$(document).ready([animateBars.bars]);

},{}],2:[function(require,module,exports){
"use strict";

var positionIconAnimation = {
    positionIcon: function positionIcon() {

        // vars
        var positionIcon = ".positionIcon",
            gpsPoint = ".gpsPoint",
            tl = new TimelineMax({
            repeat: -1
        });

        tl.to(positionIcon, 2, {
            x: 40,
            ease: Elastic.easeOut.config(0.5, 0.3)
        }).to(positionIcon, 2, {
            x: 10,
            ease: Elastic.easeOut.config(0.5, 0.3)
        }).to(positionIcon, 2, {
            x: 0,
            ease: Elastic.easeOut.config(0.5, 0.3)
        }).to(positionIcon, 2, {
            y: -40,
            scale: 0.7,
            ease: Elastic.easeOut.config(0.5, 0.3)
        }).to(positionIcon, 2, {
            y: 0,
            scale: 1,
            ease: Elastic.easeOut.config(0.5, 0.3)
        });
    }

};

$(document).ready([positionIconAnimation.positionIcon]);

},{}],3:[function(require,module,exports){
"use strict";

var animationsZone0 = {
    init: function init() {
        // vars
        var theSun = ".theSun",
            theCloud = ".theCloud",
            theRGB = ".rgb",
            config = {
            rotate: {
                rotation: '-360',
                ease: Linear.easeNone,
                repeat: -1,
                transformOrigin: '50% 50%'
            }
        };

        // rotate the sun
        function rotateSun() {
            TweenMax.to(theSun, 5, {
                rotation: 360,
                transformOrigin: "center",
                ease: SlowMo.ease.config(0.5, 0.5, false),
                repeat: -1
            });
        }

        // move the cloud
        function moveCloud() {
            TweenMax.to(theCloud, 2, {
                x: 5,
                scale: 0.9,
                yoyo: true,
                repeat: -1
            });
        }

        // animate RGB
        function animateRGB() {
            TweenMax.to(theRGB, 4, config.rotate);
        }

        rotateSun();
        moveCloud();
        animateRGB();
    }
};

$(document).ready(animationsZone0.init);

},{}],4:[function(require,module,exports){
"use strict";

var animationsZone1 = {
    tennisBall: function tennisBall() {

        // vars
        var tennisBall = ".tennisBall",
            circleArc = ".circleArc",
            circleArcHide = ".circleArcHide",
            barEyes = ".barEyes",
            tl = new TimelineMax({
            repeat: -1
        });

        tl.to(tennisBall, 2, {
            rotation: -720,
            transformOrigin: "center"
        }).to(circleArc, 2, {
            rotation: 60,
            transformOrigin: "center"
        }, "-=2").to(circleArcHide, 2, {
            rotation: 60
        }, "-=2").to(barEyes, 2, {
            rotation: -19,
            x: -5,
            y: -5,
            scale: 0.85
        }, "-=2").to(tennisBall, 2, {
            rotation: 0,
            transformOrigin: "center"
            // transformOrigin: "40% 50% 0"
        }).to(circleArc, 2, {
            rotation: 0,
            transformOrigin: "center"
        }, "-=2").to(barEyes, 2, {
            rotation: 0,
            x: 0,
            y: 0,
            scale: 1
        }, "-=2").to(circleArcHide, 2, {
            rotation: 0
        }, "-=2");
    }
};

$(document).ready([animationsZone1.tennisBall]);

},{}],5:[function(require,module,exports){
"use strict";

var animationsZone2 = {
    sliderAndPlane: function sliderAndPlane() {

        // vars
        var sliderLine = ".sliderLine",
            thePlane = ".thePlane",
            tl = new TimelineLite({
            onComplete: complete,
            onCompleteParams: ['{self}']
        }),
            tl2 = new TimelineLite({
            onComplete: complete,
            onCompleteParams: ['{self}']
        });

        tl.to(sliderLine, 1, {
            y: -10,
            ease: Elastic.easeOut.config(1, 0.3)
        }).to(sliderLine, 1.5, {
            y: 40,
            ease: Elastic.easeOut.config(1, 0.3)
        }).to(sliderLine, 1, {
            y: 20,
            ease: Elastic.easeOut.config(1, 0.3)
        }).to(sliderLine, 0.6, {
            y: 0,
            ease: Elastic.easeOut.config(1, 0.3)
        });

        tl2.to(thePlane, 1.5, {
            y: -180,
            scale: 0.95,
            ease: Power1.easeOut
        }).to(thePlane, 0.5, {
            rotation: -180,
            x: -10,
            scale: 0.80,
            skewY: "60deg"
        }, "-=0.4").to(thePlane, 0.2, {
            skewY: "0deg"
        }).to(thePlane, 1.5, {
            y: 120,
            ease: Power1.easeOut
        }, "-=0.2").to(thePlane, 0.5, {
            rotation: -360,
            x: 0,
            skewY: "-10deg"
        }).to(thePlane, 0.2, {
            skewY: "0deg"
        }).to(thePlane, 0.8, {
            y: 0,
            scale: 1,
            ease: Power1.easeOut
        });

        function complete(tl) {
            setTimeout(function () {
                tl.restart();
            }, 1000);
        }
    },

    searchIcon: function searchIcon() {

        // vars
        var searchIcon = ".searchIcon",
            hotelIcon = ".hotelIcon",
            tl = new TimelineLite({
            onComplete: complete,
            onCompleteParams: ['{self}']
        });

        tl.set(searchIcon, {
            rotation: 15,
            scale: 0.8,
            transformOrigin: "center"
        }).to(searchIcon, 1, {
            rotation: 0,
            scale: 1,
            transformOrigin: "center"
        }).to(hotelIcon, 1, {
            scale: 0.8,
            transformOrigin: "center"
        }, "-=1").to(searchIcon, 1, {
            rotation: 15,
            scale: 0.8,
            transformOrigin: "center"
        }).to(hotelIcon, 1, {
            scale: 1,
            transformOrigin: "center"
        }, "-=1");

        function complete(tl) {
            setTimeout(function () {
                tl.restart();
            }, 1000);
        }
    }
};

$(document).ready([animationsZone2.sliderAndPlane, animationsZone2.searchIcon]);

},{}],6:[function(require,module,exports){
"use strict";

var animationsZone3 = {

    animateHead: function animateHead() {

        // vars
        var iconHead1 = ".iconHead1",
            iconHead2 = ".iconHead2",
            manBody1 = ".manBody1",
            theFace = ".theFace",
            tl = new TimelineLite({
            onComplete: complete,
            onCompleteParams: ['{self}']
        });

        tl.to(iconHead1, 0.5, {
            scale: 0.8,
            transformOrigin: "center"
        }).to(iconHead2, 0.5, {
            scale: 0.8,
            transformOrigin: "center"
        }, "-=0.5").to(iconHead1, 0.5, {
            x: 2,
            transformOrigin: "center"
        }).to(theFace, 1, {
            x: 4,
            scale: 0.8
        }, "-=0.5").to(iconHead2, 0.5, {
            x: -2,
            transformOrigin: "center"
        }, "-=0.5").to(manBody1, 0.5, {
            rotation: 5,
            transformOrigin: "center"
        }, "-=1.0").to(iconHead1, 0.6, {
            x: 0,
            transformOrigin: "center"
        }, "+=1").to(theFace, 1, {
            x: 0,
            scale: 1
        }, "-=0.6").to(manBody1, 0.5, {
            rotation: 0,
            transformOrigin: "center"
        }, "-=1").to(iconHead2, 0.6, {
            x: 0,
            transformOrigin: "center"
        }, "-=1").to(iconHead1, 0.6, {
            x: -2,
            transformOrigin: "center"
        }, "+=1").to(theFace, 1, {
            x: -3,
            scale: 0.8
        }, "-=0.6").to(manBody1, 0.5, {
            rotation: -5,
            transformOrigin: "center"
        }, "-=1.1").to(iconHead2, 0.6, {
            x: 2,
            transformOrigin: "center"
        }, "-=1").to(iconHead1, 0.6, {
            x: 0,
            transformOrigin: "center"
        }, "+=1").to(theFace, 1, {
            x: 0,
            scale: 1
        }, "-=0.6").to(manBody1, 0.6, {
            rotation: 0,
            transformOrigin: "center"
        }, "-=1.1").to(iconHead2, 0.6, {
            x: 0,
            transformOrigin: "center"
        }, "-=1").to(iconHead1, 0.6, {
            scale: 1,
            transformOrigin: "center"
        }, "+=1").to(iconHead2, 0.6, {
            scale: 1,
            transformOrigin: "center"
        }, "-=1");

        function complete(tl) {
            setTimeout(function () {
                tl.restart();
            }, 1000);
        }
    },

    animateBigCircle: function animateBigCircle() {

        // vars
        var bigCircle = ".bigCircle",
            circleBg = ".circleBg",
            tl = new TimelineLite({
            onComplete: complete,
            onCompleteParams: ['{self}']
        });

        tl.to(bigCircle, 1, {
            y: 13
        }).to(bigCircle, 1, {
            y: 13
        }).to(circleBg, 1, {
            fill: "#AF4298"
        }, "-=2").to(circleBg, 1, {
            fill: "#AF4298"
        }).to(bigCircle, 1, {
            y: 0
        }).to(circleBg, 1, {
            fill: "#E63A66"
        }, "-=1");

        function complete(tl) {
            setTimeout(function () {
                tl.restart();
            }, 4000);
        }
    }
};

$(document).ready([animationsZone3.animateHead, animationsZone3.animateBigCircle]);

},{}],7:[function(require,module,exports){
"use strict";

var animationsZone4 = {
    init: function init() {

        // loop function for the pieChart
        function increaseSlice(selector, speed) {
            TweenMax.to(selector, speed, {
                scale: 1.1,
                opacity: 0.7,
                transformOrigin: "center",
                ease: Sine.easeOut
            });
        }

        // decrease slice
        function decreaseSlice(selector, speed, delay) {
            TweenMax.to(selector, speed, {
                scale: 1,
                opacity: 1,
                delay: delay,
                transformOrigin: "center",
                ease: Sine.easeOut
            });
        }

        /* Animate the dots
         */
        // loop function for the pieChart
        function moveDotUp(selector, speed) {
            TweenMax.to(selector, speed, {
                y: -5,
                scale: 0.8,
                opacity: 1,
                transformOrigin: "30% 50% 0",
                ease: Elastic.easeOut.config(0.7, 0.3)
            });
        }

        // decrease slice
        function moveDotDown(selector, speed, delay) {
            TweenMax.to(selector, speed, {
                y: 0,
                scale: 1,
                opacity: 1,
                delay: delay,
                transformOrigin: "30% 50% 0",
                ease: Elastic.easeOut.config(0.7, 0.3)
            });
        }

        // animate the pieChart
        var next = 1;
        setInterval(function () {

            var selector = ".slice" + next;
            increaseSlice(selector, 0.2);
            decreaseSlice(selector, 0.1, 0.2);
            // resetArrowColor(selector, 0.1);
            next++;

            if (next > 5) {
                next = 1;
            }
        }, 1000);

        // animate the dots
        var nextDot = 1;
        setInterval(function () {

            var selector = ".dot-" + nextDot;
            moveDotUp(selector, 3);
            moveDotDown(selector, 3, 1);
            // resetArrowColor(selector, 0.1);
            nextDot++;

            if (nextDot > 3) {
                nextDot = 1;
            }
        }, 1000);
    }
};

$(document).ready(animationsZone4.init);

},{}],8:[function(require,module,exports){
'use strict';

require('./modules/ui.js');

require('./modules/misc.js');

require('./animations/zone0.js');

require('./animations/zone4.js');

require('./animations/zone2.js');

require('./animations/zone3.js');

require('./animations/zone1.js');

require('./animations/map-pin.js');

require('./animations/bars.js');

},{"./animations/bars.js":1,"./animations/map-pin.js":2,"./animations/zone0.js":3,"./animations/zone1.js":4,"./animations/zone2.js":5,"./animations/zone3.js":6,"./animations/zone4.js":7,"./modules/misc.js":9,"./modules/ui.js":10}],9:[function(require,module,exports){
"use strict";

var animations = {
    init: function init() {
        // identify svg element
        function identifyElement(selector) {
            TweenMax.to(selector, 5, {
                rotation: 360,
                transformOrigin: "left 66%",
                ease: Linear.easeNone,
                repeat: -1
            });
        }

        identifyElement(".theGroup");
    }
};

$(document).ready(animations.init);

},{}],10:[function(require,module,exports){
'use strict';

var uiModule = {
        init: function init() {
                var isModal = false;

                /* Modal
                --------------------------------------- */

                var MODAL = [{
                        title: 'PERSONALISED SHOPPING',
                        content: 'E-commerce sites tend to be static – the on the page is the same for everyone. But Watson can help brands create a deeper relationship with customers – making the experience of online shopping less like flicking through endless racks of products and more like talking to an expert assistant.'
                }, {
                        title: 'WATSON AT WIMBLEDON',
                        content: 'Wimbledon’s “Cognitive Command Centre” was powered by Watson’s intelligence. Human experts taught Watson how to understand social discussion across Twitter, Facebook, Youtube and Instagram. More than 11 million pieces of content were analysed during Wimbledon.'
                }, {
                        title: 'BESPOKE BREAKS',
                        content: 'WayBlazer, built on Watson’s Natural Language Processing, enables travelers to search in a nuanced, personalised way – and for holiday firms to provide instant, smart answers based not just on data provided by the hotels, but blogs, reviews and more.'
                }, {
                        title: 'SOCIAL GETS SMART',
                        content: 'Beyond being able to recognise words and phrases, Watson can tap into the emotion and context of fast-moving social media – such as the conversation around sporting events. By understanding language and nuance, it can access and understand blogs, reviews, pictures and videos – unstructured data invisible to traditional search.'
                }, {
                        title: 'COOKING WITH COGNITIVE',
                        content: 'Chef Watson can generate an infinite number of recipes, based on its training from Condé Nast’s Bon Appétit magazine. The ability for Watson to learn and be taught as opposed to programmed opens up a world of possibilities for its application.'
                }];

                /* Alert
                --------------------------------------- */

                var $alert = $('.wd-alert');
                var $alertBtn = $('.wd-alert_button a');

                $alertBtn.on('click', closeAlert);

                function closeAlert() {
                        $alert.hide();
                }

                /* Modal
                --------------------------------------- */

                var $window = $(window);
                var $body = $('body');
                var $modal = $('.wd-modal');
                var $modalBtn = $('.wd-modal_close');

                $modalBtn.on('click', closeModal);
                $body.on('click', closeModal);
                $body.on('click', closeAlert);
                $modal.on('click', preventClose);

                function preventClose(e) {
                        e.stopPropagation();
                }

                function closeModal() {
                        isModal = false;
                        $modal.removeClass('wd-modal_show');
                        $content.removeClass(function (index, css) {
                                return (css.match(/\bwd-zoom_\S+/g) || []).join(' ');
                        });
                        pointOut();
                }

                /* Points
                --------------------------------------- */

                var $point = $('div[data-point]');
                var $svg = $('.wd-svg svg');
                var $circle = $('circle[data-point]');
                var $zone = $('.wd-zone');
                var $content = $('.valign-wrap');

                pointPosition();
                $window.on('resize', pointPosition);

                $point.on('mouseover', pointOver);
                $point.on('mouseout', pointOut);
                $point.on('click', function (e) {
                        var $this = $(this);
                        var point = $this.data('point');
                        preventClose(e);
                        pointClick($this);
                        $content.addClass('wd-zoom_' + point);
                });

                function pointPosition() {
                        $circle.each(function () {

                                var svgLeft = $svg.offset().left;
                                var svgTop = $svg.offset().top;

                                var left = $(this).offset().left;
                                var top = $(this).offset().top;

                                var point = $(this).data('point');
                                var offsetLeft = ($('div[data-point="' + point + '"]').width() - $(this)[0].getBoundingClientRect().width) / 2;
                                var offsetTop = ($('div[data-point="' + point + '"]').height() - $(this)[0].getBoundingClientRect().height) / 2;

                                $('div[data-point="' + point + '"]').css({
                                        left: left - svgLeft - offsetLeft,
                                        top: top - svgTop - offsetTop
                                }).fadeIn();
                        });
                }

                function pointOver() {
                        var index = $(this).data('point');

                        $zone.each(function () {
                                var zone = $(this).data('zone');

                                if (index !== zone) {
                                        $(this).addClass('wd-zone_faded');
                                }
                        });
                }

                function pointOut() {
                        if (!isModal) {
                                $zone.removeClass('wd-zone_faded');
                        }
                }

                function pointClick($this) {
                        var index = $this.data('point');
                        var title = MODAL[index].title;
                        var content = MODAL[index].content;

                        isModal = true;

                        $modal.find('.wd-modal_title').text(title);
                        $modal.find('.wd-modal_content').text(content);
                        $modal.addClass('wd-modal_show');
                }
        }
};

$(document).ready(uiModule.init);

},{}]},{},[8])

